import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const NotificationIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Notification",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m27.94 22.75-3.75-3.3v-9.24a8.209 8.209 0 1 0-16.42 0v9.23l-3.75 3.31c-.42.42-.43 1.1 0 1.52.19.19.44.3.71.32h22.56c.59-.03 1.05-.54 1.02-1.13-.01-.27-.13-.52-.32-.71h-.04Zm-8.9 3.92c.1 1.74-1.22 3.22-2.96 3.33-1.74.1-3.22-1.22-3.33-2.96v-.37z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.14 26c-.17 0-.35-.04-.51-.12-2.88-1.44-4.06-3.39-4.06-6.74v-8c0-4.41-3.59-8-8-8s-8 3.59-8 8v8c0 1.93-.39 3.4-1.28 4.57h13.85a1.14 1.14 0 1 1 0 2.28H3c-.53 0-.99-.36-1.11-.88s.13-1.05.6-1.29c1.86-.93 2.8-1.91 2.8-4.69v-8C5.29 5.47 9.9.86 15.57.86s10.29 4.61 10.29 10.29v8c0 2.78.94 3.76 2.8 4.69.56.28.79.97.51 1.53-.2.4-.6.63-1.02.63ZM20.14 30.57H11a1.14 1.14 0 1 1 0-2.28h9.14a1.14 1.14 0 1 1 0 2.28"
      })
    })
  }));
};
NotificationIcon.displayName = 'NotificationIcon';